<template>
  <dd-header-card header="Bonus/Malus">
    <BonusMalusTable v-if="primary_premium_type" :modal-visible="modalVisible" @cancel="closeTableModal" />
    <dd-form-grid>
      <dd-form-grid-item>
        <div class="flex-row align-items-end  gap-md">
          <dd-select
              class="flex-grow-1 flex-shrink-0"
              v-model="primary_premium_type"
              title="BM Tabel"
              @select="onSelect"
              :options="premiumMatricesOptions"/>
          <div>
            <dd-button @click="openTableModal" :disabled="!primary_premium_type">Bekijk tabel</dd-button>
          </div>
        </div>
      </dd-form-grid-item>
      <dd-form-grid-item>
        <dd-number-input v-model="primary_premium_step" title="Trede" :min="0"></dd-number-input>
      </dd-form-grid-item>
      <dd-form-grid-item>
        <dd-number-input v-model="claim_free_years" title="Schadevrije jaren" :min="0"></dd-number-input>
      </dd-form-grid-item>
    </dd-form-grid>
  </dd-header-card>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import {mapGetters} from "vuex";
import BonusMalusTable from "./BonusMalusTable.vue";

export default {
  name: "BonusMalus",
  components: { BonusMalusTable },
  methods: {
    openTableModal() {
      this.modalVisible = true;
    },
    closeTableModal() {
      this.modalVisible = false;
    },
    onSelect(value) {

    },
  },
  data() {
    return {
      modalVisible: false,
    };
  },
  computed: {
    ...mapFields(`$_generic_insurance`, [
      'form.primary_premium_type',
      'form.primary_premium_step',
      'form.claim_free_years',
    ]),
    ...mapGetters(`$_generic_insurance`, {
      premiumMatrices: 'premiumMatrices',
    }),
    premiumMatricesOptions() {
      return Object.entries(this.premiumMatrices).map(([id, matrix]) => {
        return {
          value: id,
          label: matrix,
        };
      });
    },
  }
};
</script>

<style scoped>

</style>
